import { AbstractControl } from '@angular/forms';

export function passwordValidator(control: AbstractControl): { [key: string]: boolean } {
  const password = control.get('password');
  const confirmPassword = control.get('confirmPassword');
  return { mismatch: password && confirmPassword && password.value !== confirmPassword.value };
}
